import type { FaireProductEntity } from "../../entity_types/product";

export const p_kpn7p6u6hf: FaireProductEntity = {
  token: "p_kpn7p6u6hf",
  type: "product",
  name: "Tie-Dyed Hip-Hop Sports SOCKS_CWMS0251",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/9cedbbb268f09ae4bd3e1aa2d2b6f94f06b002545dfbd2b5893424c78d3974f0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bba4715398aa6699d2b2b0279944a4109d116c284ed57548b4c89e06c5646ae1.jpeg",
    "https://cdn.faire.com/fastly/6daf008a0e062f42ef4399fe4e6c15c6e287b5e4f4bf2f294fce229f43d089ed.jpeg",
    "https://cdn.faire.com/fastly/5cd5d3a797c6093863bd25c1b12b00964ea54330054e49479efd96c45f0c38b2.jpeg",
    "https://cdn.faire.com/fastly/0adeccd68897772619be5e766c69ba6ccb470bd0d4c0a645f4aba59a6007df4f.jpeg",
    "https://cdn.faire.com/fastly/75f5461f4bfbfe8ba635752bddee7a49cbeb7389770be757923baf423956ecf8.jpeg",
    "https://cdn.faire.com/fastly/de7bc6df8d5e040db965408733193eb3375bf0a5c2a7f94cdc0f0b54cdb93ee9.jpeg",
    "https://cdn.faire.com/fastly/a62054532c700651e2ff87c22abc1fda507a2aff85707864c0a019c4e91991db.jpeg",
    "https://cdn.faire.com/fastly/35768ef5ac70b9e7cef690e5a5cb1a37c2f7c7b9cd975c807746a2a469c0cceb.jpeg",
    "https://cdn.faire.com/fastly/149c2921a5b3bc7aa4d95d50eed98208ee4cfc6a4a812ba9c17f827c7923fb14.jpeg",
    "https://cdn.faire.com/fastly/7f78550f2096a9c7029bc2c685e3686b4739040308a6db9a7bc008a6c22446e0.jpeg",
  ],
  priceDollars: 3.64,
  description:
    "Tie-Dyed Hip-Hop Sports Socks\nSize: OS(2)\n100% Cotton\nMade in China\n\nMen's and women's tie-dyed socks, tie-dyed sports socks, yoga socks, non-slip socks, skateboard socks, socks, socks, invisible socks, tie dye socks, sports sock, non-slip grip socks yoga, pilates, colorful socks, leisure socks, boat socks, running socks, soft socks, colorful socks, women tie-dyed socks, women yoga socks, men's sports tie-dyed socks, women boat socks, women casual tie-dyed socks",
  tags: [],
  msrpDollars: 7.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-05T00:27:24.924Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
